import React,{useEffect, useState} from "react";
import logo from './images/logo.svg';
import { NavLink,useHistory  } from "react-router-dom";

import api from "./api";


function  Home () {
  const history = useHistory();
  
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && token !== "") {
      history.push('/dashboard');
    }
  }, [])

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate input
    if (!username || !password) {
      setError('Username and password are required.');
      return;
    }

    // Make API request
    // fetch('http://brokerapp.local/index.php?xAction=login', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     username: username,
    //     password: password
    //   })
    // })
    // .then(response => response.json())
    // .then(data => {
    //   if (data.status === 1) {
    //      setIsLoggedIn(true);        // set the isLoggedIn state to true
    //     //localStorage.setItem('isLoggedIn', true);
    //     history.push('/Dashboard');
    //   }
    //   else if (data.status === 2) {
    //     setError('Username or password are incorrect');
    //     return;
    //   }
    //   else if (data.status === 3) {
        
    //   }
    //   // Handle response data
    //   console.log(data);
    // })
    // .catch(error => {
    //   // Handle error
    //   console.error(error);
    // });
    try {
      // Pass xAction as query string
      const res = await api.post(process.env.REACT_APP_LOGIN, { 
        username,
        password
      }, {credentials: "include"});
  
      if (res.data.status === 1) {
        localStorage.setItem("token", res.data.token);
        history.push("/dashboard");
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error("Login error:", err);
      alert("Something went wrong");
    }

  };

    return(
        <>
         <div id="login_page">
            <div className="login_content">        
                <div className="logo_login">
                  <img src={logo} />
                </div>
                <div className="login_form extra-margin-top-30">
                    <form onSubmit={handleSubmit}> 
                      <h3 className="bold">Please sign in to your account</h3>
                      <div className="">
                        <div className="input-group mt-4">                            
                          <div className="input-field">
                          <div className="field_icon"><i className="fa fa-user"></i></div>
                            <input type="text" id="name" className="inputfield" value={username} onChange={event => setUsername(event.target.value)}  />
                            <label for="name">Username</label>
                          </div>
                        </div>

                        <div className="input-group mt-4">                            
                          <div className="input-field">
                          <div className="field_icon"><i className="fa fa-lock"></i></div>
                            <input type="password" id="Password" className="inputfield" value={password} onChange={event => setPassword(event.target.value)} />
                            <label for="Password">Password</label>
                          </div>
                        </div>
                        

                        <div className="mt-4">
                          {/* <NavLink className="btn_login" to="/Dashboard">Log In</NavLink> */}
                          <button className="btn_login" to="" type="submit">Log In</button>
                        </div>
                        {error && <p>{error}</p>}
                      </div>
                    </form>
                </div>
            </div>
            <div id="footer_login">
              propstackCopyright © 2023 // Propstack
            </div>
          </div>
        </>
    );
};

export default Home;